var FEATURE_SEARCH_REDUCER_KEYS = /* @__PURE__ */ ((FEATURE_SEARCH_REDUCER_KEYS2) => {
  FEATURE_SEARCH_REDUCER_KEYS2["items"] = "items";
  FEATURE_SEARCH_REDUCER_KEYS2["context"] = "context";
  FEATURE_SEARCH_REDUCER_KEYS2["experimentationGroups"] = "experimentationGroups";
  return FEATURE_SEARCH_REDUCER_KEYS2;
})(FEATURE_SEARCH_REDUCER_KEYS || {});
const ACTION_PREFIX = "EXPERIMENT-SEARCH-APP-MODULE/FEATURE-SEARCH-V3";
const ACTION_TYPES = {
  LOAD_FEATURES: `${ACTION_PREFIX}/LOAD_FEATURES`,
  SET_CONTEXT: `${ACTION_PREFIX}/SET_CONTEXT`,
  SET_PARTIAL_CONTEXT: `${ACTION_PREFIX}/SET_PARTIAL_CONTEXT`,
  LOAD_EXPERIMENTATION_GROUPS: `${ACTION_PREFIX}/LOAD_EXPERIMENTATION_GROUPS`
};
const ADDITIONAL_FILTERS_ICON = "Filter";
const ADDITIONAL_FILTERS_LABEL = "Additional filters";
const ADDITIONAL_FILTERS_PRIMARY_BUTTON_LABEL = "Apply";
const ADDITIONAL_SEARCH_FILTERS_LABEL = "Additional search fields";
const ARCHIVED_LABEL = "Include archived experiments";
const CREATE_FEATURE_ARIA_LABEL = "Click to create a new feature experiment";
const CREATE_FEATURE_ICON_NAME = "Add";
const CREATE_FEATURE_TEXT = "Create a feature experiment";
const EXPERIMENTATION_GROUP_LABEL = "Experimentation group";
const ISOLATION_GROUPS_LABEL = "Isolation groups";
const KEYWORD_SEARCH_PLACEHOLDER = "Search by keyword";
const PAGING_DEFAULT_PAGE = 1;
const PAGING_DEFAULT_PAGE_SIZE = 100;
const PAGING_LABEL = "Page";
const PAGING_LEFT_LABEL = "Page left";
const PAGING_RIGHT_LABEL = "Page right";
const PAGING_PAGE_SIZE_LABEL = "Page size";
const PAGING_PAGE_SIZE_OPTIONS = ["10", "20", "50", "100"];
const CLEAR_FILTERS_BUTTON_LABEL = "Clear filters";
const SEARCH_BUTTON_LABEL = "Search";
const STARTED_AFTER_LABEL = "Started after";
const STARTED_AFTER_PLACEHOLDER = "MM/DD/YYYY";
const STARTED_BEFORE_LABEL = "Started before";
const STARTED_BEFORE_PLACEHOLDER = "MM/DD/YYYY";
const STATUS_LABEL = "Status";
const SUBSCRIBER_SEARCH_ICON_NAME = "Info";
const SUBSCRIBER_SEARCH_LABEL = "Subscriber search";
const SUBSCRIBER_SEARCH_PLACEHOLDER = "Type to search by subscriber ID or email.";
var PerformanceMarkers = /* @__PURE__ */ ((PerformanceMarkers2) => {
  PerformanceMarkers2["LoadFeatures"] = "PLT:FeatureSearch:LoadFeatures";
  return PerformanceMarkers2;
})(PerformanceMarkers || {});
export {
  ACTION_PREFIX,
  ACTION_TYPES,
  ADDITIONAL_FILTERS_ICON,
  ADDITIONAL_FILTERS_LABEL,
  ADDITIONAL_FILTERS_PRIMARY_BUTTON_LABEL,
  ADDITIONAL_SEARCH_FILTERS_LABEL,
  ARCHIVED_LABEL,
  CLEAR_FILTERS_BUTTON_LABEL,
  CREATE_FEATURE_ARIA_LABEL,
  CREATE_FEATURE_ICON_NAME,
  CREATE_FEATURE_TEXT,
  EXPERIMENTATION_GROUP_LABEL,
  FEATURE_SEARCH_REDUCER_KEYS,
  ISOLATION_GROUPS_LABEL,
  KEYWORD_SEARCH_PLACEHOLDER,
  PAGING_DEFAULT_PAGE,
  PAGING_DEFAULT_PAGE_SIZE,
  PAGING_LABEL,
  PAGING_LEFT_LABEL,
  PAGING_PAGE_SIZE_LABEL,
  PAGING_PAGE_SIZE_OPTIONS,
  PAGING_RIGHT_LABEL,
  PerformanceMarkers,
  SEARCH_BUTTON_LABEL,
  STARTED_AFTER_LABEL,
  STARTED_AFTER_PLACEHOLDER,
  STARTED_BEFORE_LABEL,
  STARTED_BEFORE_PLACEHOLDER,
  STATUS_LABEL,
  SUBSCRIBER_SEARCH_ICON_NAME,
  SUBSCRIBER_SEARCH_LABEL,
  SUBSCRIBER_SEARCH_PLACEHOLDER
};
//# sourceMappingURL=constants.js.map
